module.exports = __webpack_public_path__ + "static/media/temperature_micro.5e0a240b.svg";